var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[(_vm.isBusy)?_c('div',[_c('Loading')],1):_c('div',[_c('div',{attrs:{"id":"container"}},[_c('canvas',{attrs:{"id":"lineChart"},on:{"click":_vm.handleClick}}),_c('canvas',{staticClass:"canvas",attrs:{"id":"verticalLineCanvas"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }